import {createSlice} from '@reduxjs/toolkit';
import {CaregiverQuoteDetailsDto} from 'src/shared/services/caregiver-quotes/dto/caregiver-quote-details-dto';

interface CaregiverQuotesInitialState {
  caregiverQuoteDetails?: CaregiverQuoteDetailsDto;
  caregiverQuotesList?: Array<CaregiverQuoteDetailsDto>;
  isCaregiverQuotesListLoading?: boolean;
}

const initialState: CaregiverQuotesInitialState = {
  caregiverQuoteDetails: undefined,
  caregiverQuotesList: [],
  isCaregiverQuotesListLoading: false,
};

const caregiverQuotesSlice = createSlice({
  name: 'caregiverQuotes',
  initialState: initialState,
  reducers: {
    setCaregiverQuoteDetails: (state, action) => {
      state.caregiverQuoteDetails = action.payload;
    },
    setCaregiverQuotesList: (state, action) => {
      state.caregiverQuotesList = action.payload;
    },
    setIsCaregiverQuotesListLoading: (state, action) => {
      state.isCaregiverQuotesListLoading = action.payload;
    },
  },
});

export const {
  setCaregiverQuoteDetails,
  setCaregiverQuotesList,
  setIsCaregiverQuotesListLoading,
} = caregiverQuotesSlice.actions;

export default caregiverQuotesSlice.reducer;
